import { TimelineEventOptions } from './OpportunityTimeline.types'

export const isEmailCapturedEvent = (eventType: string): boolean => {
  return eventType === TimelineEventOptions.LEAD_CAPTURED
}

export const isMeetingBookedEvent = (eventType: string): boolean => {
  return eventType === TimelineEventOptions.MEETING_BOOKED
}
